import React, { useState } from 'react';

const QUESTIONS = [
  "Little interest or pleasure in doing things",
  "Feeling down, depressed, or hopeless",
  "Trouble falling or staying asleep, or sleeping too much",
  "Feeling tired or having little energy",
  "Poor appetite or overeating",
  "Feeling bad about yourself — or that you are a failure",
  "Trouble concentrating on things",
  "Moving or speaking so slowly or being so fidgety that others notice",
  "Thoughts that you would be better off dead or of hurting yourself"
];

const CHOICES = [
  { label: "Not at all", value: 0 },
  { label: "Several days", value: 1 },
  { label: "More than half the days", value: 2 },
  { label: "Nearly every day", value: 3 }
];

const getSeverity = (score) => {
  if (score <= 4) return "Minimal";
  if (score <= 9) return "Mild";
  if (score <= 14) return "Moderate";
  if (score <= 19) return "Moderately Severe";
  return "Severe";
};

export default function PHQ9({ onComplete }) {
  const [responses, setResponses] = useState(Array(QUESTIONS.length).fill(null));
  const [submitted, setSubmitted] = useState(false);
  const [phase, setPhase] = useState('instructions');

  const handleChange = (qIndex, value) => {
    const updated = [...responses];
    updated[qIndex] = value;
    setResponses(updated);
  };

  const handleSubmit = () => {
    if (responses.includes(null)) {
      alert("Please answer all questions.");
      return;
    }

    const total = responses.reduce((a, b) => a + b, 0);
    const severity = getSeverity(total);
    setSubmitted(true);
    if (onComplete) onComplete({ total, severity, responses });
  };

  // Instruction screen
  if (phase === 'instructions') {
    return (
      <div style={{ maxWidth: '700px', margin: '3rem auto', textAlign: 'center' }}>
        <h2>PHQ-9: Mood Questionnaire</h2>
        <p>This questionnaire helps assess your mood and well-being over the past two weeks.</p>
        <p>There are 9 questions. For each one, select how often you’ve experienced the listed symptom.</p>
        <p>Your answers are private and help support informed care and decision-making.</p>
        <button onClick={() => setPhase('questions')} style={{ marginTop: '1rem' }}>
          Begin
        </button>
      </div>
    );
  }

  // Questions screen
  if (!submitted) {
    return (
      <div style={{ maxWidth: '800px', margin: '2rem auto', padding: '1rem' }}>
        <h2 style={{ textAlign: 'center' }}>PHQ-9</h2>
        {QUESTIONS.map((question, index) => (
          <div key={index} style={{ marginBottom: '1.5rem' }}>
            <p><strong>{index + 1}. {question}</strong></p>
            <div style={{ display: 'flex', flexDirection: 'column', gap: '0.5rem' }}>
              {CHOICES.map(choice => (
                <label key={choice.value} style={{ cursor: 'pointer' }}>
                  <input
                    type="radio"
                    name={`q${index}`}
                    value={choice.value}
                    checked={responses[index] === choice.value}
                    onChange={() => handleChange(index, choice.value)}
                    style={{ marginRight: '0.5rem' }}
                  />
                  {choice.label}
                </label>
              ))}
            </div>
          </div>
        ))}
        <div style={{ textAlign: 'center' }}>
          <button onClick={handleSubmit} style={{ padding: '0.5rem 1rem' }}>
            Submit
          </button>
        </div>
      </div>
    );
  }

  // Completion screen
  const total = responses.reduce((a, b) => a + b, 0);
  const severity = getSeverity(total);

  return (
    <div style={{ textAlign: 'center', marginTop: '3rem' }}>
      <h2>PHQ-9 Complete</h2>
      <p>Total Score: <strong>{total}</strong></p>
      <p>Severity: <strong>{severity}</strong></p>
    </div>
  );
}
